import React from 'react';
import Button from '../../../../../incase-domain/components/button/Button';
import '../../../../../styles/components/genericTable.scss';

interface GridProps<T> {
    columnsNumber?: number;
    columnsGap?: string;
    rowsGap?: string;
    rows: T[];
    rowIdentifier: (row: T) => string | number;
    loading?: boolean;
    renderItem: (row: T, loading?: boolean, onSelectItem?: (row: T) => void, isSelected?: boolean) => JSX.Element;
    onSelectedItem?: (item: T) => void;
    selectedRows: {[key: string | number]: T};
    enableSelect?: boolean;
}

Grid.defaultProps = {};

function Grid<T extends Record<string, unknown> | null>(props: GridProps<T>): JSX.Element {
    const {
        columnsNumber = 3,
        columnsGap = '1rem',
        rowsGap = '1rem',
        rows,
        loading,
        rowIdentifier,
        renderItem,
        onSelectedItem,
        selectedRows,
        enableSelect,
    } = props;

    return (
        <div
            className="c-genericGrid"
            style={{
                gridTemplateColumns: `repeat(${columnsNumber},  minmax(0, 1fr))`,
                columnGap: columnsGap,
                rowGap: rowsGap,
            }}
        >
            {rows.map((row) => (
                <div key={rowIdentifier(row)} className="c-genericGrid__wrapper">
                    <div>{renderItem(row, loading, onSelectedItem, !!selectedRows[rowIdentifier(row)])}</div>
                    {enableSelect && selectedRows[rowIdentifier(row)] && (
                        <div className="c-genericGrid__checkbox">
                            <Button
                                variant="ghost"
                                size="xl"
                                padded={false}
                                dynamicSize
                                color="secondary"
                                leading={selectedRows[rowIdentifier(row)] ? 'solar:check-square-bold' : 'solar:stop-linear'}
                                onClick={(e) => {
                                    e?.stopPropagation();
                                    onSelectedItem?.(row);
                                }}
                            />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

export default Grid;
